export default __webpack_public_path__ + "static/media/particle_loading.aa6cc6e3.svg";